import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./header/header.component";
import { IonicModule } from "@ionic/angular";
// import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ShellModule } from "../shell/shell.module";
import { GoogleMapComponent } from "./google-map/google-map.component";
import { CounterInputComponent } from "./counter-input/counter-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { PrinterDetailComponent } from "./printer-detail/printer-detail.component";
// import { DirectivesModule } from '../directives/directives.module';

const components: any[] = [
  HeaderComponent,
  GoogleMapComponent,
  CounterInputComponent,
  PrinterDetailComponent
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ShellModule,
    // DirectivesModule,
    IonicModule,
    TranslateModule,
  ],
  exports: [...components],
})
export class ComponentsModule {}
